import { useEffect, useState } from "react";
import { createClinicalFormsApi } from "../api-helpers/ClinicalFormsApiHelper";
import { CareNoteRecord } from "../constants/AppointmentOverlayJourney";

// The patient's care notes (drafts and submitted), for the overlay's Care
// Management focus. Loads on mount and again whenever `reloadKey` changes (the
// overlay passes the route, so a note submitted elsewhere shows on return).
// Undefined until the first answer; a failed first load counts as none, and
// later reloads keep the last list while they run.
export function useCareNotes(
  patientId: string | undefined,
  reloadKey?: string
): CareNoteRecord[] | undefined {
  const [notes, setNotes] = useState<CareNoteRecord[] | undefined>(undefined);

  useEffect(() => {
    if (!patientId) return;

    let cancelled = false;

    const load = async () => {
      try {
        const { data } =
          await createClinicalFormsApi().clinicalFormsControllerGetMemberForms(
            patientId,
            "care-note"
          );
        if (!cancelled) setNotes(data as unknown as CareNoteRecord[]);
      } catch (error) {
        console.error("Error loading the patient's care notes:", error);
        if (!cancelled) setNotes((previous) => previous ?? []);
      }
    };

    void load();

    return () => {
      cancelled = true;
    };
  }, [patientId, reloadKey]);

  return notes;
}
